import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ILoaiQuyHoach } from 'app/shared/model/loai-quy-hoach.model';
import { getEntity, updateEntity, createEntity, reset } from './loai-quy-hoach.reducer';

export const LoaiQuyHoachUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const loaiQuyHoachEntity = useAppSelector(state => state.loaiQuyHoach.entity);
  const loading = useAppSelector(state => state.loaiQuyHoach.loading);
  const updating = useAppSelector(state => state.loaiQuyHoach.updating);
  const updateSuccess = useAppSelector(state => state.loaiQuyHoach.updateSuccess);
  const handleClose = () => {
    props.history.push('/loai-quy-hoach');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...loaiQuyHoachEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...loaiQuyHoachEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="xtdtApp.loaiQuyHoach.home.createOrEditLabel" data-cy="LoaiQuyHoachCreateUpdateHeading">
            <Translate contentKey="xtdtApp.loaiQuyHoach.home.createOrEditLabel">Create or edit a LoaiQuyHoach</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="loai-quy-hoach-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('xtdtApp.loaiQuyHoach.ten')} id="loai-quy-hoach-ten" name="ten" data-cy="ten" type="text" />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/loai-quy-hoach" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LoaiQuyHoachUpdate;
